module.exports = __webpack_public_path__ + "img/enterprise2.7ffea7bc.png";